import { valuesOf, genericSearch } from '@adreno-common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { combineLatest, merge, Observable, Subject } from 'rxjs';
import {
  scan,
  take,
  map,
  distinctUntilChanged,
  switchMap,
} from 'rxjs/operators';
import { ListCampaignQuestionsChildDto } from '../models/list-campaign-questions-vm';
import { WorkService } from '../services';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqComponent {
  private searchFn = genericSearch('question', 'answer', 'category');
  private updateSubs = new Subject<void>();
  filter = new FormControl('');
  viewModel$: Observable<ViewModel>;

  constructor(private workSvc: WorkService) {
    this.viewModel$ = this.initViewModel();
  }

  private initViewModel() {
    const questions$ = merge(
      this.updateSubs.pipe(switchMap(() => this.workSvc.master$)),
      this.workSvc.master$.pipe(
        distinctUntilChanged(
          (a, b) =>
            a?.recordId === b?.recordId || a?.campaignId === b?.campaignId
        )
      )
    ).pipe(
      switchMap((master) =>
        this.workSvc.listCampaignQuestions(
          master?.campaignId || 0,
          master?.recordId || 0
        )
      )
    );

    return merge<Partial<ViewModel>>(
      combineLatest([questions$, valuesOf<string>(this.filter)]).pipe(
        map(([questions, filter]) => {
          if (!filter || filter.trim().length == 0) return { questions };
          return {
            questions: questions?.filter((q) => this.searchFn(filter, q)) || [],
          };
        })
      )
    ).pipe(scan((acc, value) => ({ ...acc, ...value }), {} as ViewModel));
  }

  faqById(index: number, item: ListCampaignQuestionsChildDto) {
    return item.qaId;
  }

  logQuestionHistory(id: number) {
    this.workSvc.master$
      .pipe(
        take(1),
        switchMap((master) =>
          this.workSvc.recordQAHistory(
            id,
            master?.recordId ? master?.recordId : 0
          )
        )
      )
      .subscribe(() => {
        this.updateSubs.next();
      });
  }
}

interface ViewModel {
  questions: ListCampaignQuestionsChildDto[];
}
